/**
 * Map configurations from ENV values to VUE configurations
 */

 const config = {
    app: {
      title: process.env.VUE_APP_TITLE || "Videodrome",
      version: process.env.VUE_APP_VERSION || "1.0.1",
      sitePath: process.env.SITE_PATH || 'localhost'
    },
    api: {
      version: process.env.VUE_APP_API_VERSION,
      uri: process.env.VUE_APP_API_URI
    }
}

export default config;